import { EYEBROW, type ThemeClasses } from './cmsTheme.ts';

/** The headline every closed-sale notice leads with; the publisher message may repeat it. */
const ONLINE_SALES_CLOSED_HEADLINE = 'Lukket for online billetsalg';

/**
 * Splits the publisher message into the headline sentence and the rest. The BackOffice sends
 * "Der er lukket for online billetsalg." optionally followed by a sentence about buying entrance
 * tickets at the gate while the festival runs; the first sentence is already the headline, so only
 * what follows it is shown as body text.
 */
function closedNoticeBody(message: string): string {
  return message
    .replace(/^\s*Der er lukket for online billetsalg\.?\s*/i, '')
    .trim();
}

/**
 * Replaces the ticket list while online sales are closed (between this year sale closing and
 * next year opening): the publisher message, on the section card shade, and no buy button.
 * Also the fallback when ticket data cannot be loaded while a baked onlineSales block says closed,
 * so a visitor never meets a technical error in a ticket section.
 */
export function OnlineSalesClosedNotice({ message, theme }: { readonly message: string; readonly theme: ThemeClasses }) {
  const card = theme.card;
  const body = closedNoticeBody(message);
  return (
    <div
      role="status"
      className={`${card.bg} ${card.text} rounded-card p-6 md:p-9`}
    >
      <div className={`${EYEBROW} ${theme.eyebrow}`}>Billetter</div>
      <p className={`mt-3 font-display text-3xl md:text-[40px] leading-none tracking-[-0.02em] ${card.text}`}>{ONLINE_SALES_CLOSED_HEADLINE}</p>
      {body && <p className={`mt-4 text-base md:text-lg ${card.muted}`}>{body}</p>}
    </div>
  );
}
